import {gql, useLazyQuery} from "@apollo/client";
import {useLogger} from "./useLogger";
import {getBrowser} from "../common/common";

const QUERY = gql`
query getResortFeaturedImage($hapimagResortId: Int!, $locale: String!){
    resortCollection(where: {hapimagResortId: $hapimagResortId}, locale: $locale, limit: 1){
        items{
            resortInspirationImagesCollection(limit: 1){
                items{
                    title,
                    url,
                }
            }
        }
    }
}`;

export const useResortFeaturedImage = () => {
    const {logger} = useLogger();
    const [getResortFeaturedImage, { loading, data, error }] = useLazyQuery(QUERY, {
        fetchPolicy: getBrowser() === "Safari" ? "network-only" : "cache-first",
        errorPolicy: "all"
    });

    const resortFeaturedImage = data?.resortCollection?.items[0]?.resortInspirationImagesCollection?.items[0];

    if (error?.message) {
        logger(error?.message, "error", "useResortFeaturedImage", error?.stack);
    }

    return {
        getResortFeaturedImage,
        resortFeaturedImage,
        loading,
        error
    };
};
